/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import {
    ComponentRef,
    Directive,
    ElementRef,
    HostBinding,
    Input,
    OnInit,
    Renderer2,
    ViewContainerRef,
} from '@angular/core';
import {SpinnerComponent} from "../../components/spinner/spinner.component";



@Directive({
    selector: '[mat-spinner]',
    standalone: false
})
export class SpinnerDirective implements OnInit {

  @Input() matSpinnerColor: string = '--fuse-primary-700';
  @Input() diameter: number | undefined = 100;
  @Input() state: 'transparent' | 'gray' = 'gray';
  @Input() description = '';
  private shouldShow = false;
  spinner?: ComponentRef<SpinnerComponent>;


  @Input('mat-spinner')
  set matSpinner(val: boolean) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
  }

  @HostBinding('class.mat-spinner-container') isSpinnerExist = false;

  constructor(private directiveView: ViewContainerRef,
              private renderer: Renderer2,
              private directiveElement: ElementRef) {
  }

  ngOnInit() {
    if (this.shouldShow) {
      this.show();
    }
  }

  hide() {
    if (this.isSpinnerExist) {
      this.directiveView.remove();
      this.isSpinnerExist = false;
    }
  }

  show() {
    if (!this.isSpinnerExist) {
      this.spinner = this.directiveView.createComponent<SpinnerComponent>(SpinnerComponent);
      this.setInstanceInputs(this.spinner.instance);
      this.spinner.changeDetectorRef.detectChanges();
      this.renderer.appendChild(this.directiveElement.nativeElement, this.spinner.location.nativeElement);
      this.isSpinnerExist = true;
    }
  }

  setInstanceInputs(instance: SpinnerComponent) {
    typeof this.diameter !== 'undefined' && (instance.diameter = this.diameter);
    typeof this.matSpinnerColor !== 'undefined' && (instance.colorVariable = this.matSpinnerColor);
    typeof this.state !== 'undefined' && (instance.state = this.state);
    typeof this.description !== 'undefined' && (instance.description = this.description);
  }
}
